import React, { useState } from "react"
import PropTypes from "prop-types"

import { makeStyles } from "@material-ui/styles"
import { grey } from "@material-ui/core/colors"

import Cell from "./Cell"
import IdGenerator from "../../../IdGenerator"

const useStyle = makeStyles((theme) => ({
  0: {
    backgroundColor: grey[500],
    color: theme.palette.tableHead.color,
    fontWeight: "bold"
  },
  1: {
    backgroundColor: grey[400],
    fontWeight: "bold"
  },
  2: {
    backgroundColor: grey[300],
    fontWeight: "bold"
  },
  3: {
    backgroundColor: grey[200]
  },
  4: {
    backgroundColor: grey[100]
  },
  leaf: {
    "&:hover td": {
      backgroundColor: grey[200]
    }
  }
}))

const Node = ({ headers, data, isInFold, level, tr }) => {
  const [isFolded, setIsFolded] = useState(false)
  const generator = new IdGenerator()
  const classes = useStyle()

  let rowClasses = `bookmark-widget-table-tr`
  if (!data.leaf) {
    // for a better reading add some style for each row group
    rowClasses += ` ${classes[level]}`
  } else {
    rowClasses += ` ${classes.leaf}`
  }

  const foldImpl = () => setIsFolded(!isFolded)

  return (
    <>
      <tr
        className={rowClasses}
        style={{
          display: isInFold ? "none" : "table-row",
          whiteSpace: "pre"
        }}
      >
        {headers
          .filter((header) => !header.hidden)
          .map((header, id) => {
            return (
              <Cell
                data={data[header.dataIndex]}
                key={header.dataIndex}
                style={tr && tr.props.children[id].props.style}
                className={tr && tr.props.children[id].props.className}
                level={id === 0 ? level : 0}
                fold={!data.leaf && id === 0 ? foldImpl : undefined}
                isFolded={isFolded}
              />
            )
          })}
      </tr>
      {!data.leaf &&
        data.children.map((child) => (
          <Node
            headers={headers}
            data={child}
            key={generator.getId(child)}
            tr={tr}
            level={level + 1}
            isInFold={
              isInFold ||
              isFolded ||
              /* Required because child.expanded is undefined for leaves */
              child.expanded === false
            }
          />
        ))}
    </>
  )
}

Node.propTypes = {
  headers: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  isInFold: PropTypes.bool,
  level: PropTypes.number.isRequired,
  tr: PropTypes.object
}
Node.defaultProps = {
  isInFold: false,
  tr: undefined
}

export default Node
